import { Popover } from "@commonlibs";
import { CalendarValue, DayPickerRoot, DayRoot, PopoverTrigger, ScheduleCalendarRoot } from "./MonthlySchedule.styles";
import CalendarIcon from "ui/common/icons/CalendarIcon";
import { useState } from "react";
import { SchedulingTypeChildProps } from "../../SchedulingTypeGroup";
import useTranslate from "ui/locale/hooks/useTranslate";

export default function MonthlySchedule({ onChange }: SchedulingTypeChildProps) {
    const translate = useTranslate();
    const [day, setDay] = useState<string | null>(null);
    const [popoverVisibilit, setPopoverVisibility] = useState(false);

    const endDate = new Date(new Date());
    endDate.setMonth(endDate.getMonth() + 10);

    function onSelectDay(day: string) {
        setDay(day);
        setPopoverVisibility(false);
        onChange?.(day);
    }

    return (
        <ScheduleCalendarRoot>
            <CalendarValue hasValue={Boolean(day)} variant="body3Strong">
                {day || translate("chooseDate")}
            </CalendarValue>
            <Popover
                style={{ width: "100%" }}
                showOn="click"
                visible={popoverVisibilit}
                onHide={() => setPopoverVisibility(false)}
                onShow={() => setPopoverVisibility(true)}
            >
                <Popover.Content>
                    <PopoverTrigger>
                        <CalendarIcon width={25} height={25} />
                    </PopoverTrigger>
                </Popover.Content>
                <Popover.Popper>
                    <DayPickerRoot>
                        {Array.from({ length: 31 }, (_, index) => index + 1).map((item) => (
                            <DayRoot selected={String(item) === day} onClick={() => onSelectDay(String(item))} key={item}>
                                {item}
                            </DayRoot>
                        ))}
                    </DayPickerRoot>
                </Popover.Popper>
            </Popover>
        </ScheduleCalendarRoot>
    );
}
